<template>
    <div class="bg-gray-50 border border-gray-200 p-4">
        <!-- Title and actions. -->
        <div class="flex items-center">
            <div class="w-6 flex-shrink-0">
                <estimates-old-specs-icon :spec="form"></estimates-old-specs-icon>
            </div>
            <div class="flex-1 ml-1">
                <input
                    placeholder="Enter a title for this spec..."
                    class="text-lg m-0 px-2 py-1 font-bold text-gray-900 border-transparent bg-transparent rounded shadow-none relative focus:z-10"
                    type="text"
                    ref="name"
                    v-model="form.title"
                    @input="readOnly ? null : $emit('updated')"
                    :disabled="readOnly"
                >
            </div>
            <div class="w-6 flex-shrink-0 ml-2" v-if="! readOnly">
                <ui-dropdown placement="bottom-end" menu-class="p-3 w-64">
                    <template #default="{ toggle }">
                        <button @click="toggle" class="text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:z-10 relative p-1 rounded">
                            <i class="fa fa-ellipsis-h"></i>
                        </button>
                    </template>

                    <template #menu="{ close }">
                        <ui-dropdown-item icon="fas fa-copy" @click.stop.prevent="$emit('duplicate-and-replace')">Duplicate and replace</ui-dropdown-item>
                        <ui-dropdown-item icon="fas fa-trash" danger @click.stop.prevent="$emit('detach')">Remove from item</ui-dropdown-item>
                        <ui-dropdown-divider></ui-dropdown-divider>
                        <ui-dropdown-item icon="fas fa-file-export" @click.stop.prevent="$emit('copy-to-global-spec'); close()">Copy to Global Spec Library</ui-dropdown-item>
                    </template>
                </ui-dropdown>
            </div>
        </div>

        <!-- Other fields. -->
        <ui-form-section class="mt-6">
            <ui-textarea autoresize label="Note" rows="1" v-model="form.description" @input="readOnly ? null : $emit('updated')" :disabled="readOnly"></ui-textarea>
            <ui-input v-if="useQuantities" label="Quantity" :value="quantity" @change="readOnly ? null : updateQuantity($event)" class="sm:col-span-4" :disabled="readOnly"></ui-input>
            <ui-input label="NBS" v-model="form.nbs" @input="readOnly ? null : $emit('updated')" :class="useQuantities ? 'sm:col-span-4' : 'sm:col-span-6'" :disabled="readOnly"></ui-input>
            <ui-input label="Unit of measure" v-model="form.unit_of_measure" @input="readOnly ? null : $emit('updated')" :class="useQuantities ? 'sm:col-span-4' : 'sm:col-span-6'" :disabled="readOnly"></ui-input>
        </ui-form-section>
    </div>
</template>

<script>
import { asNumber } from '@utils'

export default {
    props: {
        form: Object,
        quantity: Number,
        readOnly: Boolean,
    },
    computed: {
        useQuantities () {
            return this.quantity !== undefined
        },
    },
    methods: {
        updateQuantity (quantity) {
            this.$emit('update:quantity', asNumber(quantity))
        },
    },
}
</script>
